import { render, staticRenderFns } from "./CloseSquare.vue?vue&type=template&id=36871e8b"
import script from "./CloseSquare.vue?vue&type=script&lang=js"
export * from "./CloseSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports